new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        // Troca do produto vinculado (cor) de um item do kit. O clique vem do template
        // templatetags/produtos/product_detail_widget_variations_abstract.html
        getInfo(event, id) {
            const actualElement = event.target;
            const itemKit = actualElement.closest('.product-item-kit');
            if (!itemKit) return;

            axios.get(`/api/front/product/${id}/get-linked-product/`)
                .then(res => {
                    const slide = itemKit.closest('.itens-for-carousel');

                    // Os complementos são do produto antigo, não valem para a cor nova
                    if (slide) {
                        slide.querySelectorAll('.complements').forEach(el => el.remove());
                    }

                    itemKit.querySelectorAll('.product__colors-item.is-selected')
                        .forEach(el => el.classList.remove('is-selected'));
                    const clickedColor = actualElement.closest('.product__colors-item');
                    if (clickedColor) clickedColor.classList.add('is-selected');

                    itemKit.setAttribute('data-product-item-kit-id', res.data.id);
                    // Marca a escolha explícita do cliente: a cor inicial já vem marcada no HTML
                    itemKit.setAttribute('data-color-selected', 'true');

                    const nameEl = itemKit.querySelector('.name span');
                    const thumbEl = itemKit.querySelector('.name img');
                    if (nameEl) nameEl.innerHTML = res.data.name;
                    if (thumbEl) thumbEl.src = res.data.thumbnail;

                    this.renderKitSizes(itemKit, res.data);
                    this.renderKitAddons(slide, id, res.data.addons || []);
                    this.updateKitGallery(res.data.images || []);

                    // O estado do botão comprar é calculado no escopo do $(document).ready
                    $(document).trigger('kit:item-changed');
                })
                .catch(err => {
                    console.log(err);
                });
        },

        // Recria os tamanhos do item do kit com as variações da cor escolhida
        renderKitSizes(itemKit, data) {
            const sizes = (data.variations || [])
                .filter(variation => variation.main_attribute != null)
                .sort((a, b) => a.main_attribute.order - b.main_attribute.order);

            // Produto sem variação (ex.: boné) é resolvido só pela cor; o data-no-variations
            // precisa acompanhar a troca, senão o item trava (ou libera) o kit indevidamente
            if (sizes.length) {
                itemKit.removeAttribute('data-no-variations');
            } else {
                itemKit.setAttribute('data-no-variations', 'true');
            }

            // O container só existe quando o item já tinha tamanhos. Sem ele
            // nextElementSibling é null (ou o bloco de complementos, que não pode ser
            // sobrescrito), então é preciso validar antes de mexer e criar quando faltar.
            let variations = itemKit.nextElementSibling;
            if (variations && !variations.classList.contains('product-radio-variation')) {
                variations = null;
            }
            if (!variations) {
                if (!sizes.length) return;
                variations = document.createElement('div');
                variations.className = 'product-radio-variation radio-content container_general attribute';
                itemKit.parentNode.insertBefore(variations, itemKit.nextSibling);
            }

            // Sem tamanho não pode sobrar o rótulo "Selecione o tamanho" sozinho na tela
            variations.innerHTML = sizes.length ? '<p class="label_attributes">Selecione o tamanho</p>' : '';

            // Os tamanhos do mesmo item precisam compartilhar o name, mas cada slide
            // precisa de um grupo próprio: kits com produtos repetidos podem ter o mesmo
            // produto/variação em mais de um slide e não podem compartilhar name nem id.
            const btnAddToCart = document.querySelector('.js-btn__product_detail__add_to_cart');
            const idAuto = btnAddToCart ? btnAddToCart.getAttribute('data-id-auto') : '';
            const slide = itemKit.closest('.itens-for-carousel');
            const slideKey = slide && slide.id ? slide.id.replace(/[^a-zA-Z0-9_-]/g, '') : 'item';
            const groupName = `product_item_variation__product_detail_${idAuto}_${data.id}_${slideKey}`;

            sizes.forEach(size => {
                const inputId = `product_item_variation__product_detail_${idAuto}_${size.id}_${slideKey}`;
                const stock = size.available === false ? 'out-of-stock' : '';
                variations.insertAdjacentHTML('beforeend', `<input type="radio" name="${groupName}" id="${inputId}" value="${size.id}" data-id="${size.id}" data-id-auto="${idAuto}" data-variation-name="${size.main_attribute.name}" data-origin-location="product_detail"><label for="${inputId}" class="label_radio ${stock} radio"><span>${size.main_attribute.value}</span></label>`);
            });
        },

        // Recria os complementos do item do kit para a cor escolhida
        renderKitAddons(slide, id, addons) {
            if (!slide || !addons.length) return;

            const complements = document.createElement('div');
            complements.setAttribute('id', `js-product_addons__product_detail_${id}`);
            complements.setAttribute('class', 'complements js-product_addons__product_detail_kit');
            complements.setAttribute('complements-for', `${id}`);
            complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';

            addons.forEach(addon => {
                const optional = addon.is_required === false ? 'True' : 'False';
                const addonPrice = addon.price ? addon.price : '';
                complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${addon.id}" addon-id="${addon.id}" addon-price="${addonPrice}" for="addon-${addon.id}" data-addon-is-optional="${optional}">${addon.field_label}</label>`);

                if (addon.field_type === 'radio_options') {
                    const select = document.createElement('select');
                    select.setAttribute('name', `addon-${addon.id}`);
                    select.setAttribute('id', `addon-select-${addon.id}`);
                    (addon.field_options || []).forEach(opt => select.add(new Option(opt, opt)));

                    const selectDiv = document.createElement('div');
                    selectDiv.setAttribute('class', 'complements-content');
                    selectDiv.appendChild(select);
                    complements.appendChild(selectDiv);
                } else if (addon.field_type === 'text') {
                    const inputDiv = document.createElement('div');
                    inputDiv.setAttribute('class', 'complements-content-area');
                    inputDiv.innerHTML = `<input name="addon-${addon.id}" type="text" maxlength="${addon.field_char_limit}">`;
                    complements.appendChild(inputDiv);
                }

                if (addonPrice) {
                    complements.insertAdjacentHTML('beforeend', `<label class="addon-price" style="margin: 0 0 25px 0;">(+ R$ ${addonPrice} )</label>`);
                }
            });

            slide.appendChild(complements);
        },

        // Troca as fotos da vitrine pelas do produto vinculado escolhido.
        // Nos modos gallery-left/right o #product-photo vira um slick: reescrever o HTML
        // ali quebra o slider, então esse modo fica de fora.
        updateKitGallery(images) {
            if (!images.length) return;

            const productPhoto = document.querySelector('#product-photo');
            if (productPhoto && !productPhoto.classList.contains('slick-initialized')) {
                const photoUl = productPhoto.querySelector('ul');
                if (photoUl) {
                    photoUl.innerHTML = images.map(src => `<li class="sp-wrap"><a href="${src}" data-fancybox="gallery1"><img src="${src}" class="product-detail__header--photoArea-mobile-img" width="100%"></a></li>`).join('');
                } else {
                    productPhoto.innerHTML = images.map(src => `<a href="${src}" data-fancybox="gallery2"><img src="${src}" width="100%"></a>`).join('');
                }
            }

            const photoList = document.querySelector('#photo-list');
            if (photoList && !photoList.classList.contains('slick-initialized')) {
                photoList.innerHTML = images.map(src => `<li class="sp-wrap"><img src="${src}" width="100%"></li>`).join('');
            }

            const $mobile = $('.mobile-slider, .product-detail__header--photoArea-mobile');
            $mobile.each(function () {
                const $slider = $(this);
                const markup = images.map(src => `<a href="${src}" data-fancybox="gallery3" class="mobile-slider-item"><img class="product-detail__header--photoArea-mobile-img" src="${src}" width="100%"></a>`);

                if ($slider.hasClass('slick-initialized')) {
                    const total = $slider.slick('getSlick').slideCount;
                    for (let i = total - 1; i >= 0; i--) {
                        $slider.slick('slickRemove', i);
                    }
                    markup.forEach(html => $slider.slick('slickAdd', html));
                    $slider.slick('slickGoTo', 0);
                } else {
                    $slider.html(markup.join(''));
                }
            });

            $('#photo-fancy').fancybox();
        },

        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img, #product-photo video');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            // Remove active de todos os photoListItem
                            photoListItem.forEach((item) => {
                                item.classList.remove('active');
                            });
                            // Remove active de todos os singlePhotoItem
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            // Adiciona active no item clicado e na imagem correspondente
                            photoListItem[index].classList.add('active');
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }
            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#product-photo').slick({
                        swipeToSlide: true,
                        touchThreshold: 100,
                        arrows: false,
                        dots: false,
                        infinite: false,
                        mobileFirst: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        speed: 300,
                    });

                    // Sincroniza os cliques do #photo-list com o slider do #product-photo
                    let photoListItems = document.querySelectorAll('#photo-list li');

                    if (photoListItems.length) {
                        photoListItems.forEach((item, index) => {
                            item.addEventListener('click', function () {
                                // Remove a classe active de todos os itens
                                photoListItems.forEach(li => li.classList.remove('active'));

                                // Adiciona active no item clicado
                                this.classList.add('active');

                                // Calcula o slide correto considerando o slidesToShow
                                const slidesToShow = 2; // mesmo valor configurado no Slick
                                const totalItems = photoListItems.length;
                                const lastSlideIndex = Math.max(0, totalItems - slidesToShow);

                                // Se o índice ultrapassar o último slide válido, vai para o último
                                const slideIndex = Math.min(index, lastSlideIndex);

                                // Navega para o slide correspondente no #product-photo
                                $('#product-photo').slick('slickGoTo', slideIndex);
                            });
                        });

                        // Adiciona active no primeiro item ao carregar
                        if (photoListItems[0]) {
                            photoListItems[0].classList.add('active');
                        }
                    }
                }
            }

            // if(photoArea.classList.contains('default')) {
            //     if (window.matchMedia("(min-width: 992px)").matches) {
            //         let lastScrollTop = 0;

            //         function animeScroll() {
            //             const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //             const banner = document.querySelector('.product-detail__banner');
            //             const appHeader = document.getElementById('app_header');

            //             if (photoScroll) {
            //                 const infoArea = document.querySelector('.product-detail__header--infoArea');
            //                 const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
            //                 const containerHeight = $container.outerHeight();
            //                 const containerTop = $container.offset() ? $container.offset().top : 0;
            //                 const sidebarOuterHeight = $('.sidebar__inner').outerHeight();
            //                 const containerWidth = $container.width();
            //                 const totalHeight = containerHeight - sidebarOuterHeight; // deslocamento máximo relativo ao container
            //                 const pageTop = window.scrollY;

            //                 // Verifica se existe banner e calcula quando ele sai da tela
            //                 let bannerOffset = 0;
            //                 if (banner) {
            //                     const bannerRect = banner.getBoundingClientRect();
            //                     const bannerHeight = banner.offsetHeight;
            //                     bannerOffset = bannerHeight;
            //                 }

            //                 // Calcula a altura do header para o top na volta
            //                 let headerHeight = 0;
            //                 if (appHeader) {
            //                     headerHeight = appHeader.offsetHeight;
            //                 }

            //                 // Limites de scroll baseados no container e header
            //                 const safeTotalHeight = Math.max(0, totalHeight);
            //                 const startScroll = containerTop - headerHeight; // ponto para começar a fixar
            //                 const endScroll = containerTop + containerHeight - headerHeight - sidebarOuterHeight; // ponto para parar a fixação

            //                 if (pageTop <= startScroll) {
            //                     // Antes do container tocar o header: posição normal
            //                     $('.sidebar__inner').css({ position: 'relative' });
            //                     $('.sidebar__inner').css({ top: "0px" });
            //                     $('.sidebar__inner').css({ width: "100%" });
            //                     $('.sidebar__inner').css({ maxWidth: "100%" });
            //                 } else if (pageTop >= endScroll) {
            //                     // Depois do final do container: travado no rodapé do container
            //                     $('.sidebar__inner').css({ position: 'relative' });
            //                     $('.sidebar__inner').css({ top: safeTotalHeight + "px" });
            //                     $('.sidebar__inner').css({ width: "100%" });
            //                     $('.sidebar__inner').css({ maxWidth: "100%" });
            //                 } else {
            //                     // Dentro da faixa: fixo logo abaixo do header e com a largura do container
            //                     $('.sidebar__inner').css({ position: 'fixed' });
            //                     $('.sidebar__inner').css({ top: headerHeight + "px" });
            //                     if (containerWidth) {
            //                         $('.sidebar__inner').css({ width: containerWidth + "px" });
            //                         $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
            //                     }
            //                 }

            //                 lastScrollTop = pageTop;
            //             }
            //         }

            //         window.addEventListener('scroll', function () {
            //             if (screen.width > 991) {
            //                 const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //                 if (photoScroll) {
            //                     animeScroll();
            //                 }
            //             }
            //         });

            //         window.onresize = function () {
            //             const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //             if (photoScroll) {
            //                 if ($('.sidebar__inner').css('position') === 'fixed') {
            //                     const infoArea = document.querySelector('.product-detail__header--infoArea');
            //                     const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
            //                     const containerWidth = $container.width();
            //                     if (containerWidth) {
            //                         $('.sidebar__inner').css({ width: containerWidth + "px" });
            //                         $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
            //                     }
            //                 }
            //             }
            //         };
            //     }
            // }
            if (photoArea.classList.contains('gallery-scroll')) {
                let productPhoto = document.querySelector('#product-photo');
                let productImage = productPhoto.querySelector('img');
                let imageHeight = productImage ? productImage.getBoundingClientRect().height : 0;
                productPhoto.style.maxHeight = imageHeight + 'px';

                let thumbsContainer = document.querySelector('.product-detail__header--photoArea-thumbs');
                if (thumbsContainer) {
                    thumbsContainer.style.maxHeight = imageHeight + 'px';
                }

                let thumbsLarge = document.querySelectorAll('#product-photo a');
                let miniThumbs = document.querySelectorAll('.product-detail__header--photoArea-thumbs #photo-list li');
                if (thumbsLarge.length && miniThumbs.length) {
                    miniThumbs.forEach((thumb, index) => {
                        thumb.addEventListener('click', (e) => {
                            // Centraliza a thumb clicada no container de thumbs
                            thumb.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest'
                            });

                            // Navega para a foto principal correspondente
                            const target = thumbsLarge[index];
                            if (target) {
                                target.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        });
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {

        const cashback = document.querySelector('.cashback-themes');
        if (cashback) {
            const cashbackValue = cashback.querySelector('.cashback-themes-value');

            // Converte "R$ 1.234,56" / "1234.56" / "10%" em número
            function toNumber(text) {
                if (!text) return NaN;

                let clean = String(text).replace(/[^\d,.]/g, '');

                if (clean.indexOf(',') > -1) {
                    clean = clean.replace(/\./g, '').replace(',', '.');
                } else if (/^\d{1,3}(\.\d{3})+$/.test(clean)) {
                    // "1.234" é milhar, não decimal
                    clean = clean.replace(/\./g, '');
                }

                return parseFloat(clean);
            }

            function getPriceArea() {
                return document.querySelector('.price[data-price-full]') || document.querySelector('.price');
            }

            function updateCashback() {
                const priceArea = getPriceArea();
                if (!cashbackValue || !priceArea) return;

                const percentage = toNumber(cashback.getAttribute('data-percentage'));
                const price = toNumber(priceArea.getAttribute('data-price-full'));

                if (isNaN(percentage) || isNaN(price)) {
                    cashbackValue.textContent = '';
                    return;
                }

                cashbackValue.textContent = (price * percentage / 100).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });
            }

            updateCashback();

            // O preço é re-renderizado ao trocar de variação: observa o container
            // pai para sobreviver à troca do próprio nó .price
            const priceArea = getPriceArea();
            if (priceArea) {
                new MutationObserver(updateCashback).observe(priceArea.parentElement || priceArea, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['data-price-full']
                });
            }
        }

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            navTab[0].classList.add('active');
            navShow[0].classList.add('active');

            if (navTab.length && navShow.length) {
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // remove todas as classes active
                    navTab.forEach((content) => content.classList.remove('active'));
                    navShow.forEach((content) => content.classList.remove('active'));

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
            }
        }

        const groupSizeTitle = document.querySelector('.group-size .group-size-title');
        const productRadioVariation = document.querySelector('.product-radio-variation .label_attributes');
        if (groupSizeTitle && productRadioVariation) {
            groupSizeTitle.textContent = productRadioVariation.textContent;
        }

        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        this.clickThumbs();

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
})

$(document).ready(function () {

    (function () {
        var trigger = document.querySelector('.js-size-guide-trigger');
        var modal = document.querySelector('[data-size-guide-modal]');
        if (!trigger || !modal) return;

        function openModal(e) {
            e.preventDefault();
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.documentElement.classList.add('size-guide-open');
            document.body.classList.add('size-guide-open');
        }

        function closeModal() {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            document.documentElement.classList.remove('size-guide-open');
            document.body.classList.remove('size-guide-open');
        }

        trigger.addEventListener('click', openModal);

        Array.prototype.forEach.call(modal.querySelectorAll('[data-size-guide-close]'), function (el) {
            el.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', function (e) {
            if ((e.key === 'Escape' || e.keyCode === 27) && modal.classList.contains('is-open')) {
                closeModal();
            }
        });
    })();

    // ---- Kit: gate de seleção dos itens ------------------------------------
    // Todos os widgets de variação (select, radio e cor/imagem) usam este prefixo de name
    const KIT_VARIATION_SELECTOR = '[name^="product_item_variation__product_detail_"]';

    function getKitVariationInputs(slide) {
        return Array.from(slide.querySelectorAll(KIT_VARIATION_SELECTOR)).filter(input => {
            return input.tagName === 'SELECT' || input.type === 'radio';
        });
    }

    // Somente itens marcados como sem variação (ex.: boné) exigem que o cliente
    // clique numa cor. A cor inicial já vem marcada no HTML, então só vale a
    // escolha explícita registrada pelo getInfo em data-color-selected.
    function kitSlideNeedsColor(slide) {
        const itemKit = slide.querySelector('.js_product_item_kit');
        const hasColors = Boolean(slide.querySelector('.kitcolors .product__colors-item'));
        const hasNoVariations = Boolean(itemKit && itemKit.getAttribute('data-no-variations'));

        if (!hasNoVariations || !hasColors) {
            return false;
        }

        return !itemKit.getAttribute('data-color-selected');
    }

    // Item do kit resolvido: não exige escolha ou o cliente já escolheu a variação
    function isKitSlideReady(slide) {
        if (kitSlideNeedsColor(slide)) {
            return false;
        }

        const itemKit = slide.querySelector('.js_product_item_kit');

        if (itemKit && itemKit.getAttribute('data-no-variations')) {
            return true;
        }

        const inputs = getKitVariationInputs(slide);

        if (!inputs.length) {
            return true;
        }

        // Basta uma escolha: o widget do kit renderiza um único atributo (o principal),
        // e não dá para exigir "um selecionado por name" porque o HTML recriado na troca
        // de cor pode vir com um name diferente por rádio.
        return inputs.some(input => {
            return input.tagName === 'SELECT' ? Boolean(input.value) : input.checked;
        });
    }

    // O gate vale para o carrossel que o Splide monta (o primeiro da página): com a
    // barra de compra fixa ligada o widget pode aparecer duplicado no DOM, e a cópia
    // não montada nunca recebe clique do cliente
    function getKitSlides() {
        const carousel = document.querySelector('.carousel-kit');
        return Array.from((carousel || document).querySelectorAll('.itens-for-carousel'));
    }

    function checkAllKitItemsHaveSizes() {
        // Sem itens de kit na página não há nada a travar
        return getKitSlides().every(isKitSlideReady);
    }

    function updateAddToCartButtonState() {
        const addToCartButtons = document.querySelectorAll('.js-btn__product_detail__add_to_cart');
        if (!addToCartButtons.length) return;

        const allItemsHaveSizes = checkAllKitItemsHaveSizes();
        addToCartButtons.forEach(button => {
            button.classList.toggle('no-buy', !allItemsHaveSizes);
        });
    }

    // Delegado e sem depender de rádio, porque os itens são recriados ao trocar de
    // cor (produtos vinculados) e o widget pode ser select em vez de rádio
    $(document).on('change', '.carousel-kit ' + KIT_VARIATION_SELECTOR, updateAddToCartButtonState);

    $(document).on('click', '.carousel-kit', function () {
        window.setTimeout(updateAddToCartButtonState, 0);
    });

    // Disparado pelo getInfo depois de trocar o produto vinculado (cor) do item
    $(document).on('kit:item-changed', updateAddToCartButtonState);

    updateAddToCartButtonState();

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            height: 'auto', // Isso aqui ativa o adaptive height
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            // Kit sem variação nenhuma já nasce liberado para comprar
            updateAddToCartButtonState();

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));

                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });

        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.carousel-kit .splide__slide.is-active');

                if (!activeSlide || isKitSlideReady(activeSlide)) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.innerHTML = kitSlideNeedsColor(activeSlide)
                        ? '<i></i> Selecione a cor para continuar'
                        : '<i></i> Selecione uma opção para continuar';
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
            updateAddToCartButtonState();
        });
    }


    $("body").on("click", ".btn-group.btn-minus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        }

        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    });

    $("body").on("click", ".btn-group.btn-plus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        } else {
            qtd++;
        }
        qt_el.val(qtd);
    });

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_SELECTOR = '#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2';

        // Rastreia quais grupos o usuário já selecionou tamanho (não depende do DOM)
        const selectedGroups = new Set();

        const getGroups = () => Array.from(document.querySelectorAll(GROUP_SELECTOR));

        // Garante please-select em grupos novos e atualiza o botão
        const syncUI = () => {
            const groups = getGroups();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!addCartBtn) return;

            groups.forEach(group => {
                if (!selectedGroups.has(group.id)) {
                    group.classList.add('please-select');
                }
            });

            const allSelected = groups.length > 0 && groups.every(g => selectedGroups.has(g.id));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        // Marca grupo como selecionado pelo usuário
        const markSelected = (group) => {
            if (!group || !group.id) return;
            selectedGroups.add(group.id);
            group.classList.remove('please-select');
            syncUI();
        };

        const container = document.querySelector('#js_buy_together_api_layout_1_groups');
        if (!container) return;

        // change = seleção em select, radio, checkbox
        container.addEventListener('change', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;
            const group = target.closest(GROUP_SELECTOR);
            if (group) markSelected(group);
        }, { passive: true });

        // click em label/input = fallback para radios customizados
        container.addEventListener('click', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;
            if (target.closest('label') || target.matches('input')) {
                const group = target.closest(GROUP_SELECTOR);
                if (group) setTimeout(() => markSelected(group), 0);
            }
        }, { passive: true });

        // Observa novos grupos sendo adicionados para colocar please-select
        const observer = new MutationObserver(() => syncUI());
        observer.observe(container, { childList: true, subtree: true });

        // Inicializa
        syncUI();
    });

    let listBuyTogether = document.getElementById('js_buy_together_api_layout_1_groups'),
        options = {
            childList: true
        }
    if (listBuyTogether) {
        observer = new MutationObserver(Callback);
        observer.observe(listBuyTogether, options);

        function Callback() {
            const products = document.querySelectorAll('#js_buy_together_api_layout_1_groups ul');
            if (products.length) {
                products.forEach(product => {
                    if (product.dataset.buyTogetherBound) return;
                    product.dataset.buyTogetherBound = '1';

                    const options = product.querySelector('.product-item__options');
                    if (options) {
                        options.addEventListener('click', () => {
                            const radioVariation = options.querySelector('.product-radio-variation');
                            if (radioVariation) {
                                radioVariation.classList.toggle('active');
                            }
                            product.classList.toggle('active');
                        });

                        if (window.matchMedia("(max-width: 991px)").matches) {
                            const detailList = product.querySelector('.product-item__content--container');
                            if (detailList) {
                                detailList.appendChild(options);
                            }
                        }
                    }
                });
            }
        }
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const compreJunto = document.querySelector('#js_buy_together_api_layout_1');
    if (compreJunto) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                    }
                });
            });
        });

        observer.observe(compreJunto, {
            childList: true,
            subtree: true
        });

    }

    if ($('.product-detail__header--photoArea-mobile, .mobile-slider')) {
        $('.product-detail__header--photoArea-mobile, .mobile-slider').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 300,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel').length) {
        $('#product-detail-related-carrousel').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                },
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();

    if ($('.product-rating__review-list').length) {
        $('.product-rating__review-list').slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                }
            ]
        });
    }
})